import { useEffect } from 'react';
import store from '../config/store';
import { useDocumentTitle } from '../hooks';

export default function RouteComponent({
  pageTitle,
  backPath = null,
  children,
}) {
  const setPageTitle = store.useApp((state) => state.setPageTitle);
  const setBackPath = store.useApp((state) => state.setBackPath);

  useEffect(() => {
    setPageTitle(pageTitle);
    setBackPath(backPath);
  }, [pageTitle, backPath]); // eslint-disable-line

  useDocumentTitle(pageTitle);

  return <div>{children}</div>;
}
